export const figure47 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    marginLeft: 200,
    spacingBottom: 45,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    height: '600px',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false,
  }, 
  exporting: {
    enabled: false
  },
  colors: ['#5b9bd5', '#ed7d31'],
  xAxis: {
      categories: [
        "Monde",
        "",
        "Petits États insulaires en développement (PEID)",
        "Pays en développement sans littoral (PDSL)",
        "Pays les moins avancés (PMA)",
        "",
        "Afrique subsaharienne",
        "Océanie (hors Australie et Nouvelle-Zélande)",
        "Afrique du Nord et Asie de l’Ouest",
        "Amérique latine et Caraïbes ",
        "Europe et Amérique du Nord",
        "Asie du Sud et du Sud-Est",
        "Asie centrale et du Sud",
        "Australie et Nouvelle-Zélande",
  ],
      crosshair: true
  },
  yAxis: {
      max: 110,
      min: 85,
      tickInterval: 5,
      title: {
          text: null
      }
  },
  tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
  },
  plotOptions: {
      column: {
          pointPadding: 0.2,
          borderWidth: 0
      }
  },
  series: [
  {
      name: 'Food Loss index by region',
      data: [
        {y: 101.20, color: '#ffbf00'},
        {y: 0, color: '#5b9bd5'},  
        {y: 107.73, color: '#5b9bd5'},
        {y: 104.10, color: '#5b9bd5'},
        {y: 102.62, color: '#5b9bd5'},
        {y: 0, color: '#5b9bd5'}, 
        {y: 103.27, color: '#5b9bd5'},
        {y: 107.44, color: '#5b9bd5'},
        {y: 106.31, color: '#5b9bd5'},
        {y: 100.50, color: '#5b9bd5'},
        {y: 106.53, color: '#5b9bd5'},
        {y: 99.48, color: '#5b9bd5'},
        {y: 94.91, color: '#5b9bd5'},
        {y: 104.25, color: '#5b9bd5'},   
      ]
  
  },
  ]
  }